import styled, { css } from 'styled-components';
import { breakpoint, color, font } from 'styles/globals';
import { getBodyStyle, getColor } from 'styles/theme';
import type { Theme } from 'styles/theme';
import Heading from 'styles/typography/Heading';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  margin-bottom: 48px;

  .breadcrumbs {
    margin-bottom: 24px;
  }
`;

const commonPadding = css`
  padding: 0 20px;

  @media (${breakpoint.mdMin}) {
    padding: 0;
  }
`;

export const Header = styled.div`
  ${commonPadding}
  margin-bottom: 20px;
`;

export const HubDescription = styled.p<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'default' })};
  margin: 0 0 40px;
  font-size: 18px;
  padding: 0 20px;

  > a {
    font-weight: bold;
    color: ${getColor('accentPrimary')};
  }
  
  @media (${breakpoint.mdMin}) {
    padding: 0;
  }
`;

export const SectionsWrapper = styled.div`
  ${commonPadding}
  display: flex;
  flex-direction: column;
  gap: 48px;

  @media (${breakpoint.lgMin}) {
    gap: 68px;
  }

  .simple-homepage {
    margin-top: 0;
  }
`;

export const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (${breakpoint.hybridMin}) {
    flex-direction: row;
    gap: 24px;
  }

  .rr-section-hub {
    > div:first-child {
      display: block;
    }
  }

  .rr-sticky-hub{
    margin-bottom: 0;
  }
`;

export const ArticleWrapper = styled.div`
  margin-bottom: 32px;

  @media (${breakpoint.hybridMin}) {
    width: calc(100% - 360px);
  }

  .title {
    font-family: ${font.saolText};
  }
`;

export const LatestWrapper = styled.div`
  margin-bottom: 32px;

  .section-latest {
    .title-link {
      font-size: 18px;

      @media (${breakpoint.lgMin}) {
        font-size: 20px;
      }
    }
  }
`;

export const PageInfo = styled(Heading)<{ theme: Theme }>`
  padding-top: 8px;
  align-self: flex-start;
  font-weight: 400;
  line-height: 150%;
`;

export const RightRail = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  align-items: center;
  
  & > .eduRightRailNav:only-child{
    width: 100%;
  }

  @media (${breakpoint.mdMin}) {
    flex-shrink: 0;
    margin-top: 62px;

    .video-module {
      padding-left: 24px;
      border-left: 4px solid ${color.lightBlue};
    }
  }

  @media (${breakpoint.lgMin}) {
      flex-basis: 336px; 
      margin-bottom: 24px;
  }

  @media ((-webkit-device-pixel-ratio: 1.875) or (-webkit-device-pixel-ratio: 2.125) ) 
  and (${breakpoint.mdMin}) 
  and (${breakpoint.lgMax}) {
    flex-basis: 328px; 
  }
`;

export const MoreWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (${breakpoint.hybridMin}) {
    flex-direction: row;
    gap: 24px;
  }
`;
